import React from 'react';

export default function PaymentMonitoring() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Payment Monitoring</h1>
      <p className="text-gray-500">Halaman Payment Monitoring</p>
    </div>
  );
}
